//헤더 컴포넌트
import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import images from "../../../../assets/styles/Images";
import { palette } from "../../../../assets/styles/Palette";
import {
  Body2,
  Sub1,
  Sub2,
  Sub3,
  Caption2,
} from "../../../../assets/styles/Typography";
import {
  CreditTotal,
  CreditDashBoardItem,
  CreditNoData,
} from "../../../../assets/styles/BusinessAnalysisStyle";
import { useAtom } from "jotai";
import {
  PERSONA_STEP,
  USER_CREDITS,
  IS_LOGGED_IN,
  PROJECT_SAAS,
  EDUCATION_STATE,
  IS_SOCIAL_LOGGED_IN,
  USER_NAME,
  USER_EMAIL,
  SELECTED_CUSTOMER_TYPE,
} from "../../../AtomStates";
import { getUserMemberType, getUserInfo, getEduBoardListOnServer } from "../../../../utils/indexedDB";
import { useDynamicViewport } from "../../../../assets/DynamicViewport";
import PopupWrap from "../../../../assets/styles/Popup";
import MoleculeAccountPopup from "../../../LoginSign/components/molecules/MoleculeAccountPopup";
const MoleculeHeader = ({ centerTitle }) => {
  useDynamicViewport("width=1280"); // 특정페이지에서만 pc화면처럼 보이기
  const navigate = useNavigate();

  const [personaStep] = useAtom(PERSONA_STEP);
  const location = useLocation();
  const [showAlert, setShowAlert] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [showRedDot, setShowRedDot] = useState(false);
  const [showCreditToggle, setShowCreditToggle] = useState(false);
  const [isClosingCreditToggle, setIsClosingCreditToggle] = useState(false);
  const [userCredits, setUserCredits] = useAtom(USER_CREDITS);
  const [isLoggedInState, setIsLoggedInState] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [alarms, setAlarms] = useState([]);
  const [projectSaas] = useAtom(PROJECT_SAAS);
  const [educationState, setEducationState] = useAtom(EDUCATION_STATE);
  const [isSocialLoggedIn, setIsSocialLoggedIn] = useAtom(IS_SOCIAL_LOGGED_IN);
  const [userName, setUserName] = useAtom(USER_NAME);
  const [userEmail, setUserEmail] = useAtom(USER_EMAIL);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [memberType, setMemberType] = useState(0);
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [selectedCustomerType, setSelectedCustomerType] = useAtom(
    SELECTED_CUSTOMER_TYPE
  );
  const [managedBoardsCount, setManagedBoardsCount] = useState(0);

  const logoutBtnRef = useRef(null);
  useEffect(() => {
    if (isLoggedIn) fetchMemberType();
  }, [isLoggedIn]);

  const [showLogoutDropdown, setShowLogoutDropdown] = useState(false);
  

  // 로그아웃 버튼 클릭 핸들러
  const handleLogoutClick = () => {
    setShowLogoutDropdown(prev => !prev);
  };

  // 로그아웃 확인 핸들러
  const handleLogoutConfirm = () => {
    let url_address = "/Login";
    if (educationState) {
      url_address = "/Login";
    }
    sessionStorage.clear(); // 세션 스토리지 모두 삭제
    localStorage.clear(); // 로컬 스토리지 모두 삭제
    setIsLoggedIn(false);
    setIsSocialLoggedIn(false);
    setUserName("");
    setUserEmail("");
    setShowLogoutPopup(false); // 로그아웃 팝업 닫기
    window.location.href = url_address; // 페이지 이동
  };

  // 로그아웃 취소 핸들러
  const handleCloseLogoutPopup = () => {
    setShowLogoutPopup(false);
  };

  const fetchMemberType = async () => {
    if (isLoggedIn) {
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      setMemberType(memberType.member_type);

      // memberType이 31인 경우 관리하는 게시판 개수 확인
      if (memberType.member_type === 31) {
        try {
          const userInfo = await getUserInfo(accessToken);
          const eduBoardList = await getEduBoardListOnServer(999, 1, true);
          
          if (eduBoardList && eduBoardList.data) {
            const userEmail = userInfo.email;
            const managedBoards = eduBoardList.data.filter(board => board.manager === userEmail);
            setManagedBoardsCount(managedBoards.length);
          }
        } catch (error) {
          console.error("Failed to fetch managed boards count:", error);
          setManagedBoardsCount(0);
        }
      }
    }
  };

  useEffect(() => {
    fetchMemberType();
  }, [isLoggedIn]);

  const handleOpenInquiryModal = () => {
    setShowLogoutDropdown(false);
    navigate("/MyPage");
  };

  const currentUrl = window.location.href;

  const handleCustomerManageClick = () => {
    console.log("memberType:", memberType)
    if (memberType === 31 || memberType === 32 || Number(selectedCustomerType) === 3) {
      navigate("/EduboardManage");
    } else if (memberType === 42 || Number(selectedCustomerType) === 4) {
      navigate("/CustomerManageInfoBoard");
    }else if (memberType === 12 || memberType === 22 || Number(selectedCustomerType) === 1 || Number(selectedCustomerType) === 2 ){
      navigate("/CustomerManage");
    } else if (memberType === 52 || Number(selectedCustomerType) === 5) {
      navigate("/EduInfoBoardManage");
    }else {
      navigate("/Admin");
    }
  };

  const handleAdminClick = () => {
    navigate("/Admin");
  };

  const handleExitCancel = () => {
    setShowExitPopup(false);
  };

  const handleExitConfirm = () => {
    setShowExitPopup(false);
    navigate("/");
  };

  return (
    <>
      <HeaderWrap>
        <LogoContainer>
          <Sub1
            color="gray800"
            style={{ fontWeight: "600", cursor: "pointer" }}
            onClick={() => setShowExitPopup(true)}
          >
            Autodisplay
          </Sub1>
          {currentUrl.toLowerCase().includes("dashboard") &&
            (memberType === 12 ||
              memberType === 22 ||
              memberType === 42 ||
              Number(selectedCustomerType) === 3 ||
              memberType === 99 || memberType >= 100) && (
              <LogoutButton onClick={handleCustomerManageClick}>
                {Number(selectedCustomerType) === 3
                  ? "교내 게시판 관리"
                  : "고객사 관리"}
              </LogoutButton>
            )}
          {(currentUrl.toLowerCase().includes("customermanage")  || currentUrl.toLowerCase().includes("eduboardmanage") || currentUrl.toLowerCase().includes("eduinfoboardmanage")) &&
            (memberType === 99 || memberType >= 100) && (
              <LogoutButton onClick={handleAdminClick}>admin</LogoutButton>
            )}
        </LogoContainer>
        {centerTitle && <CenterTitle>{centerTitle}</CenterTitle>}

        {isLoggedIn && (
          <Gnb>
            <LogoutWrapper>
              <LogoutButton ref={logoutBtnRef} onClick={handleLogoutClick}>
                <img src={images.AccountSetting} alt="계정 설정" />
                <span>계정 설정</span>
              </LogoutButton>
              {showLogoutDropdown && (
                <LogoutDropdown isToggle={!showLogoutDropdown}>
                  <div className="info">
                    <div className="userName" style={{color: "#666666"}}>
                      <strong>{userName}</strong>
                      {/* <Grade General={memberType === 0} /> */}
                    </div>
                    <Caption2 color="gray500" align="left">
                      {userEmail}
                    </Caption2>
                  </div>
                  <ul>
                    <li>
                      <button onClick={handleOpenInquiryModal}>
                        <img src={images.AccountMypage} alt="" />
                        <span style={{color: "#666666"}}>계정 관리</span>
                      </button>
                    </li>
                    <li>
                      <button onClick={handleLogoutConfirm}>
                        <img src={images.AccountLogout} alt="" />
                        <span style={{color: "#666666"}}>로그아웃</span>
                      </button>
                    </li>
                  </ul>
                </LogoutDropdown>
              )}
            </LogoutWrapper>
          </Gnb>
        )}
      </HeaderWrap>

      {showLogoutPopup && (
        <Popup Cancel onClick={handleCloseLogoutPopup}>
          <div>
            <button
              type="button"
              className="closePopup"
              onClick={handleCloseLogoutPopup}
            >
              닫기
            </button>
            <span>
              <img src={images.ExclamationMark} alt="" />
            </span>
            <p>
              <strong>정말 로그아웃하시겠습니까?</strong>
              <span>로그아웃하시면 모든 계정 세션이 종료됩니다.</span>
            </p>
            <div className="btnWrap">
              <button type="button" onClick={handleLogoutConfirm}>
                확인
              </button>
            </div>
          </div>
        </Popup>
      )}
      {showExitPopup && (
        <PopupWrap
          Warning={true}
          title="홈으로 이동하시겠습니까?"
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={handleExitCancel}
          onConfirm={handleExitConfirm}
        />
      )}
    </>
  );
};

export default MoleculeHeader;

// 새로운 로고 컨테이너 스타일드 컴포넌트
const LogoContainer = styled.div`
  position: absolute;
  left: 28px;
  display: flex;
  align-items: center;
`;

const ActionButton = styled.button`
  margin-left: 12px;
  padding: 4px 8px;
  font-size: 0.875rem;
  border: none;
  background: ${palette.chatGray};
  border-radius: 4px;
  cursor: pointer;
  &:hover { background: ${palette.gray100}; }
`;
 
const Gnb = styled.div`
  display: flex;
  margin-left: auto;
`;
 
const LogoutWrapper = styled.div`
  position: relative;
`;

const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
  z-index: 9999;

  .closePopup {
    position: absolute;
    right: 24px;
    top: 24px;
    width: 16px;
    height: 16px;
    font-size: 0;
    padding: 11px;
    border: 0;
    background: none;

    &:before,
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 100%;
      border-radius: 10px;
      background: ${palette.black};
      content: "";
    }

    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  > div {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    text-align: center;
    // overflow:hidden;
    padding: 45px 24px 24px;
    border-radius: 10px;
    background: ${palette.white};

    p {
      font-family: "Pretendard", "Poppins";
      font-size: 0.875rem;
      font-weight: 500;
      margin: 20px auto 24px;
      strong {
        font-weight: 500;
        display: block;
      }

      span {
        font-size: 0.75rem !important;
        font-weight: 400;
        color: #8c8c8c;
        display: block;
        margin-top: 8px;
      }
    }

    .btnWrap {
      display: flex;
      align-items: center;
      gap: 16px;

      button {
        flex: 1;
        font-family: "Pretendard", "Poppins";
        font-size: 0.875rem;
        font-weight: 600;
        color: ${palette.blue};
        padding: 12px 20px;
        border-radius: 12px;
        border: 1px solid ${palette.blue};
        background: ${palette.white};

        &:last-child {
          color: ${palette.white};
          background: ${palette.blue};
        }
      }
    }

    ${(props) =>
      props.Cancel &&
      css`
        p {
          strong {
            font-weight: 600;
            display: block;
          }
          span {
            font-size: 1rem;
            display: block;
            margin-top: 8px;
          }
        }

        .btnWrap {
          padding-top: 16px;
          border-top: 1px solid ${palette.lineGray};

          button {
            color: ${palette.gray};
            font-weight: 600;
            padding: 0;
            border: 0;
            background: none;

            &:last-child {
              color: ${palette.primary};
              background: none;
            }
          }
        }
      `}
  }
`;

// 크레딧 관련 스타일드 컴포넌트 주석처리
/* const TotalCreditToggle = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

const CreditToggle = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 240px;
  padding: 16px;
  border-radius: 5px;
  background: ${palette.white};
  box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.3s ease-in-out;
  z-index: 100;

  &.closing {
    animation: fadeOut 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      font-family: "Pretendard", "Poppins";
      padding: 2px 4px;
      border-radius: 5px;
      border: 0;
      background: ${palette.chatGray};
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;

      + li {
        padding-top: 8px;
        border-top: 1px solid ${palette.chatGray};
      }
    }
  }
`; */

const HeaderWrap = styled.div`
   position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
  padding: 10px 28px;
  border-bottom: 1px solid ${palette.lineGray};
  background: ${palette.white};
  z-index: 99;
`;

const Title = styled(Body2)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    cursor: pointer;

    &:hover {
      path {
        fill: #0b45b1;
      }
    }
  }

  .businessAnalysis {
    position: absolute;
    top: 30px;
    // left: 77px;
    left: 50%;
    transform: none;
    width: 816px;
    margin-left: -408px;
    z-index: 100;
    animation: fadeIn 0.3s ease-in-out;
    border-radius: 15px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;

    > div:nth-child(1) {
      display: none;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const CloseButton = styled.div`
  position: absolute;
  top: 32px;
  right: 24px;
  width: 16px;
  height: 16px;
  cursor: pointer;

  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
    height: 2px;
    background: ${palette.gray700};
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

// 알림 관련 스타일드 컴포넌트 주석처리
/*
const Notify = styled.div`
  position: relative;
  cursor: pointer;

  ${(props) =>
    props.Alarm &&
    css`
      &::after {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 6px;
        height: 6px;
        background: ${palette.red};
        border-radius: 100px;
        content: "";
        animation: blink 1.5s infinite;
      }

      @keyframes blink {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    `}
`;

const AlertToogle = styled.div`
  position: fixed;
  top: 40px;
  right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 396px;
  width: 100%;
  // margin-top: 20px;
  margin-top: 3px;
  border-radius: 15px;
  background: ${palette.white};
  filter: drop-shadow(0px 4px 30px rgba(0, 0, 0, 0.15));
  z-index: 99;
  animation: fadeIn 0.3s ease-in-out;

  &.closing {
    animation: fadeOut 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

  &:before {
    position: absolute;
    top: -10px;
    right: 70px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${palette.white};
    // content: '';
  }
`;

const AlertHeader = styled.div`
  width: 100%;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  color: ${palette.gray800};
  text-align: left;
  padding: 20px 16px;
  border-bottom: 1px solid ${palette.outlineGray};
`;

const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow-y: auto;
  max-height: 460px;
`;

const Messageox = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.NoAlarm ? "column" : "row")};
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: ${(props) => (props.NoAlarm ? "38px 0" : "16px")};
  // padding: 16px;
  transition: all 0.5s;

  > p {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5;
    color: ${palette.gray500};
  }

  > img {
    width: 28px;
    height: 28px;
  }

  & + & {
    border-top: 1px solid ${palette.outlineGray};
  }

  &:hover {
    background: ${(props) =>
      props.NoAlarm ? "transparent" : "rgba(34, 111, 255, 0.04)"};
    // background: rgba(34, 111, 255, 0.04);
  }
`;

const Message = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
`;

const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  p {
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.5;
    color: ${palette.gray800};
    text-align: left;
  }

  strong {
    font-weight: 500;
  }

  span {
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.5;
    color: ${palette.gray500};
    text-align: left;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
`;

const Button = styled.div`
  font-size: 0.75rem;
  line-height: 1.2;
  color: ${palette.primary};
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid ${palette.primary};
  background: ${palette.white};
  cursor: pointer;
`;
*/

// 로그아웃 관련 스타일드 컴포넌트
const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "Pretendard", "Poppins";
  font-size: 14px;
  font-weight: 500;
  color: ${palette.gray600};

  img {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: ${palette.gray50};
    color: ${palette.gray700};
  }
`;

const LogoutDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 240px;
  background: ${palette.white};
  box-shadow: 0 4px 28px rgba(0,0,0,0.05);
  border-radius: 8px;
  padding: ${props => props.isToggle ? 0 : `16px`};
  max-height: ${props => props.isToggle ? 0 : `500px`};
  overflow: hidden;
  opacity: ${props => props.isToggle ? 0 : 1};
  visibility: ${props => props.isToggle ? `hidden` : `visible`};
  transition: all 0.3s ease;
 
  .info {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid ${palette.lineGray};
 
    .userName {
      display: flex;
      align-items: center;
      gap: 6px;
      strong { font-size: 1rem; }
    }
  }
 
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      button {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 8px 0;
        border: none;
        background: none;
        cursor: pointer;
        &:hover { background: ${palette.chatGray}; }
      }
    }
  }
`;

const Grade = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 4px;
  background: ${props => props.General ? palette.primaryLightest : palette.primary};
  &:before {
    content: "${props => props.General ? `일반` : `구독`}";
    font-size: 0.63rem;
    font-weight: 500;
    color: ${props => props.General ? palette.primary : palette.white};
  }
`;

const LogoutPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const LogoutPopupContainer = styled.div`
  width: 400px;
  max-width: 90vw;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;

const LogoutPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid ${palette.outlineGray};
`;

const LogoutCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${palette.gray500};
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${palette.gray700};
  }
`;

const LogoutPopupBody = styled.div`
  padding: 32px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ExclamationIcon = styled.div`
  font-size: 48px;
  margin-bottom: 8px;
`;

const LogoutMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  strong {
    font-size: 18px;
    font-weight: 600;
    color: ${palette.gray800};
  }

  span {
    font-size: 14px;
    color: ${palette.gray600};
  }
`;

const LogoutPopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid ${palette.outlineGray};
`;

const CancelButton = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid ${palette.outlineGray};
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${palette.gray50};
  }
`;

const ConfirmButton = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid ${palette.primary};
  background: ${palette.primary};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${palette.primary}DD;
  }
`;

const CenterTitle = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-family: "Pretendard", "Poppins";
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray800};
  pointer-events: none; /* 중앙 타이틀이 클릭 방해 안 하도록 */
`;
